import { createStore } from 'vuex'
import persistence from './modules/persistence'
import viewData from './modules/viewData'
import createPersistedState from 'vuex-persistedstate'

interface RootState {
  persistence: typeof import('./modules/persistence').default.state;
  viewData: typeof import('./modules/viewData').default.state;
}

export default createStore({
  state: {} as RootState,  // 类型断言
  mutations: {
  },
  actions: {
  },
  modules: {
    persistence,
    viewData
  },
  plugins: [
    createPersistedState({
      key: 'my-data',
      paths: ['persistence'],
      storage: window.sessionStorage,
    })
  ]
})
